.input {
  background-color: white;
  color: var(--mantine-color-gray-9);
  border-radius: var(--mantine-radius-sm);
  border: 1px solid var(--mantine-color-gray-2);
  padding-inline-end: 16px;
  text-overflow: ellipsis;
  &[data-error] {
    border: 1px solid var(--mantine-color-red-6);
  }

  &::placeholder {
    color: var(--mantine-color-gray-6);
  }
}

.label {
  font-size: var(--mantine-font-size-xs);
  background-color: transparent;
  width: 100%;
}

.root [data-combobox-option] {
  width: 100%;
  padding: 0;
  color: var(--mantine-color-gray-6);
}

.optionRender [data-checked="true"] {
  color: var(--mantine-color-white);
}

.dropdown * > [data-combobox-option] {
  padding: 0;
}

.root [data-combobox-option] [data-checked="true"] {
  width: 100%;
  background-color: var(--mantine-color-primary);
  color: var(--mantine-color-white);
}

.root [data-combobox-option] [data-checked="true"] p {
  color: var(--mantine-color-white);
  font-weight: bold;
}

.input {
  &[data-error="true"] {
    border: 1px solid var(--mantine-color-red-3);
    color: var(--mantine-color-red-6);
  }
}

.section {
  pointer-events: all;
}

.createLabel {
  cursor: pointer;
  flex-wrap: nowrap;
  width: 100%;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  color: var(--mantine-color-primary);
}

.createLabel p {
  color: var(--mantine-color-primary);
  font-weight: bold;
  white-space: wrap;
  word-break: break-all;
}

.createLabel svg {
  min-height: 16px;
}

.labelWithEllipsis {
  width: 100%;
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
}
